import React, { Component } from 'react'
import { Col, Row } from '../../../SPRINTA/atoms/Grid'
import AspectRatio from '../../../SPRINTA/atoms/AspectRatio'
import ActionBtnIcon from '../../../SPRINTA/molecules/ActionBtnIcon'
import { numberFormat } from '../../../SPRINTA/helpers/Formatter'
import styles from './style.css'

export default class Cart extends Component {
    state = {
      loading: true,
      canEdit: true
    }

    componentWillMount() {
      if(this.props.canEdit !== undefined) {
        this.setState({
          canEdit: this.props.canEdit
        })
      }
    }

    setMsg(type, msg) {
      this.setState({
        [`msg${type}`]: msg
      })
      
      window.setTimeout(() => {
        this.setState({
          [`msg${type}`]: null
        })
      }, 3000)
    }

    changeQuantity(inx, calc) {
      var cart = this.props.cart
      var item = cart[inx]
      var qtdy = item.quantity + (calc)

      qtdy = qtdy < 1 ? 1 : qtdy

      qtdy = item.maxQuantity < qtdy ? item.maxQuantity : qtdy
      
      item.quantity = qtdy
      cart[inx] = item
      this.props.setCart(cart)
    }

    removeItem(inx) {
      var cart = this.props.cart
      cart.splice(inx, 1)
      this.props.setCart(cart)
    }

    handleSubmit(e) {
      e.preventDefault()
      this.saveOrder({})
    }

   render() {

      var total = 0
      return (
         <div>
            <h1 style={{fontWeight: 400, marginBottom: '30px'}}>Revisão do pedido</h1>
            
            {this.props.cart.length === 0 ? (
               <div style={{ textAlign: 'center', fontSize: '14px' }}>
                  Você não possuí nenhum item!
               </div>
            ) : (
               <div>
                  <div className={styles.kitItems}>
                     {this.props.cart.map((item, inx) => {
                        total += item.price * item.quantity
                        return (
                           <div key={`${item.id}${item.option}`} className={styles.kitItem}>
                              <Row>
                                 <Col size="12 6" text="left">
                                    <div className={styles.photoItem}>
                                       <div style={{width: '65px', marginRight: '10px'}}>
                                          <AspectRatio image={`${window.config.url_event_extras_images}${item.image}`} />
                                       </div>
                                       <div style={{ display: 'flex', alignItems: 'center' }}>
                                          <p  style={{ margin: 0 }}><b>{item.description}</b><br />{item.options_name} {item.option_label}</p>
                                       </div>
                                    </div>
                                 </Col>
                                 <Col size='12 6' style={{ marginTop: '10px' }}>
                                    <Row style={{ display: 'flex', flexWrap: "wrap", alignItems: 'center' }}>
                                       <Col size="6 4" text="center right">
                                          {this.state.canEdit && (
                                            <ActionBtnIcon action={() => this.changeQuantity(inx, -1)} size={20} theme='rounded-orange' icon='menos' style={{ display: 'inline-block' }} />
                                          )}
                                          
                                          <span style={{ padding: '0 10px' }}>{item.quantity}</span>
                                          
                                          {this.state.canEdit && (                                          
                                            <ActionBtnIcon action={() => this.changeQuantity(inx, 1)} size={20} theme='rounded-orange' icon='more' style={{ display: 'inline-block' }} />
                                          )}
                                       </Col>
                                       <Col size="6 3" text="center right">
                                          <p>R$ {numberFormat(item.price)}</p>
                                       </Col>
                                       <Col size="12 5" text="center right">
                                          <span style={{ paddingRight: '10px' }}>
                                             R$ {numberFormat(item.price * item.quantity, 2, ',', '.')}
                                          </span>
                                          {this.state.canEdit && (                                          
                                            <ActionBtnIcon action={() => this.removeItem(inx)} theme='rounded-orange' icon='trash' style={{ display: 'inline-block' }} />
                                          )}
                                       </Col>
                                    </Row>
                                 </Col>
                              </Row>
                           </div>
                        )
                     })}

                     <Row>
                        <Col size="12" text="right">
                           <div className={styles.footer}>
                              Total <b>R$ {numberFormat(total, 2, ',', '.')}</b>
                           </div>
                        </Col>
                     </Row>
                  </div>

               </div>
            )}            
         </div>         
      )
   }
}


// WEBPACK FOOTER //
// ./src/components/organisms/CartOrder/index.js